/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Tier2ServiceRaiseResponse
 */
export interface Tier2ServiceRaiseResponse {
    /**
     * 
     * @type {string}
     * @memberof Tier2ServiceRaiseResponse
     */
    tier2Id?: string | null;
}

/**
 * Check if a given object implements the Tier2ServiceRaiseResponse interface.
 */
export function instanceOfTier2ServiceRaiseResponse(value: object): value is Tier2ServiceRaiseResponse {
    return true;
}

export function Tier2ServiceRaiseResponseFromJSON(json: any): Tier2ServiceRaiseResponse {
    return Tier2ServiceRaiseResponseFromJSONTyped(json, false);
}

export function Tier2ServiceRaiseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tier2ServiceRaiseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tier2Id': json['tier2Id'] == null ? undefined : json['tier2Id'],
    };
}

export function Tier2ServiceRaiseResponseToJSON(json: any): Tier2ServiceRaiseResponse {
    return Tier2ServiceRaiseResponseToJSONTyped(json, false);
}

export function Tier2ServiceRaiseResponseToJSONTyped(value?: Tier2ServiceRaiseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tier2Id': value['tier2Id'],
    };
}

